import { UNIT_TRANSLATED } from '@enmon/commons';
import { Descriptions, Skeleton } from 'antd';
import { ImageUploadReview } from 'components/ImageUpload/ImageUploadReview';
import { useMeterContext } from 'contexts/Meter';
import { useMeterModels } from 'hooks/meter_models/useMeterModels';
import { Fragment, useMemo, VFC } from 'react';
import { FormattedMessage } from 'react-intl';
import { useReplaceMeterStore } from 'routes/meter_replacement/useStore';
import { NewValuesDescriptions as messages } from '../messages';

export const NewValuesDescriptions: VFC = () => {
  const { newSerialNumber, newRegisterStates, calibrated, manufactured, manufacturer, meterModel } =
    useReplaceMeterStore();
  const { enmonMeter } = useMeterContext();
  const { commodity } = enmonMeter ?? {};

  const { meterModels, manufacturersOptions, isLoading } = useMeterModels(commodity ?? undefined);

  const meterModelName = useMemo(
    () => meterModels?.find(model => model.id === meterModel)?.name,
    [meterModels, meterModel],
  );
  const meterManufacturerName = useMemo(
    () => manufacturersOptions?.find(manufacturerOption => manufacturerOption.value === manufacturer)?.label,
    [manufacturersOptions, manufacturer],
  );

  return (
    <Descriptions
      bordered
      column={{ xxl: 2, xl: 2, lg: 2, md: 2, sm: 1, xs: 1 }}
      size="small"
      title={<FormattedMessage {...messages.newMeter} />}
    >
      <Descriptions.Item label={<FormattedMessage {...messages.serialNumber} />}>{newSerialNumber}</Descriptions.Item>
      <Descriptions.Item label={<FormattedMessage {...messages.manufacturer} />}>
        {isLoading ? <Skeleton.Input active size="small" /> : meterManufacturerName}
      </Descriptions.Item>
      <Descriptions.Item label={<FormattedMessage {...messages.meterModel} />}>
        {isLoading ? <Skeleton.Input active size="small" /> : meterModelName}
      </Descriptions.Item>
      <Descriptions.Item label={<FormattedMessage {...messages.manufactured} />}>
        {manufactured?.year()}
      </Descriptions.Item>
      <Descriptions.Item label={<FormattedMessage {...messages.calibrated} />}>{calibrated?.year()}</Descriptions.Item>

      {newRegisterStates?.map((register, index) => (
        // eslint-disable-next-line react/no-array-index-key
        <Fragment key={index}>
          <Descriptions.Item
            label={<FormattedMessage {...messages.registerName} values={{ register: index + 1 }} />}
            span={1}
          >
            {register.name} ({register.fullObis ?? '-'})
          </Descriptions.Item>

          <Descriptions.Item
            label={<FormattedMessage {...messages.registerStatus} values={{ register: index + 1 }} />}
            span={1}
          >
            {register.counter} {register.unit && UNIT_TRANSLATED[register.unit]}
          </Descriptions.Item>
          <Descriptions.Item
            label={<FormattedMessage {...messages.registerPhotos} values={{ register: index + 1 }} />}
            span={2}
          >
            <ImageUploadReview fileList={register.photos} previewWidth={150} />
          </Descriptions.Item>
        </Fragment>
      ))}
    </Descriptions>
  );
};
